module.exports = __webpack_public_path__ + "lp/img/download.8500673a.svg";